import api from "./api";

const buildQueryParams = (params = {}) => {
  const q = new URLSearchParams();
  // Keep same parameter names used by /csrp/dashboard (se-dashboard)
  if (params.createdBy) q.append("createdBy", params.createdBy);
  if (params.fromDate) q.append("fromDate", params.fromDate);
  if (params.toDate) q.append("toDate", params.toDate);
  if (params.statusCode) q.append("statusCode", params.statusCode);
  if (params.productVerticalCode) q.append("productVerticalCode", params.productVerticalCode);
  if (params.countryCode) q.append("countryCode", params.countryCode);
  if (params.zoneCode) q.append("zoneCode", params.zoneCode);
  if (params.regionCode) q.append("regionCode", params.regionCode);
  if (params.territoryCode) q.append("territoryCode", params.territoryCode);
  if (params.invoiceNumber) q.append("invoiceNumber", params.invoiceNumber);
  return q;
};

export const claimPortalDashboardApi = {
  getDashboardData: async (params = {}) => {
    const queryParams = buildQueryParams(params);
    const response = await api.get(
      `/api/claim-portal-dashboard/dashboard-data${
        queryParams.toString() ? `?${queryParams}` : ""
      }`
    );
    return response.data;
  },
};

